import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponseBase } from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize, tap, timeout } from 'rxjs/operators';
import { LoadingService } from './loading.service';
import { MessageService } from './message.service';

const resolvedPromise = Promise.resolve(null);

@Injectable()
export class FrqHttpInterceptor implements HttpInterceptor {
    constructor(
        private loadingService: LoadingService,
        private messageService: MessageService
    ) {}

    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        const timeoutValue = request.headers.get('timeout') || 300000; // define o timeout em milissegundos

        this.loadingService.start();

        resolvedPromise.then(() => this.messageService.removeOld());

        return next.handle(request).pipe(
            timeout(Number(timeoutValue)),
            tap(event => this.handleWarnMessage(event)),
            finalize(() => this.loadingService.end())
        );
    }

    private handleWarnMessage(event: HttpEvent<unknown>): void {
        if (!(event instanceof HttpResponseBase) || !event.headers) {
            return;
        }
        const headerValue = event.headers.getAll('Warn-Message');
        if (headerValue && headerValue.length) {
            const messages = JSON.parse(headerValue[0]);
            Array.isArray(messages) && resolvedPromise.then(() => messages.forEach(msg => this.messageService.warn(msg)));
        }
    }
}
